<template>
    <div class='tep-view-main-container'>
        <div id='tep-tree-grid-container' class='tep-view-container'>
            <view-tep-tree
                ref='tepTree'
                @tree-item-click='onItemClick'
                @create-item='onCreateItem'
                @delete-item='onDeleteItem'
                @refresh-card-data="onRefreshCardData"
            ></view-tep-tree>
        </div>
        <div id='tep-cards-container' class='tep-view-container'>
            <view-tep-cards
                ref='tepCards'
                @change-tree-data='onChangeTreeData'
                @create-tree-data='onCreateTreeData'
            ></view-tep-cards>
        </div>
    </div>
</template>

<script>
export default {
    name: 'view-tep-grid',
};
</script>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue';
import { getCookie } from '@/utils/cookies';
import tepCardsStore from '@/views/tep/tep-grid/store/tep-cards-store';
import store from '@/views/tep/tep-grid/store/tep-tree-store';
import ViewTepTree from '@/views/tep/tep-grid/view-tep-tree.vue';
import ViewTepCards from '@/views/tep/tep-grid/view-tep-cards.vue';

const tepCards = ref();
const tepTree = ref();

onBeforeMount(() => {
    if (tepCardsStore.state.allRatesList.length === 0)
        tepCardsStore.loadRatesList();
});

onMounted( () => {
    if(+getCookie('dep') !== store.state.department) {
        if(tepCardsStore.state.selectedItem) tepCardsStore.getSelectedItem(null);
        return;
    }
    if(tepCardsStore.state.selectedItem) {
        onItemClick(tepCardsStore.state.selectedItem);
        tepTree.value?.scrollToItem(tepCardsStore.state.selectedItem);
    }
})

const onItemClick = (data) => {
    tepCards.value?.changeCard(data);
    tepCardsStore.getSelectedItem(data);
}

const onCreateItem = (itemData) => {
    tepCards.value?.changeCard(itemData);
}

const onDeleteItem = (itemKod) => {
    tepCards.value?.clearCard(itemKod)
}

const onChangeTreeData = (filter = null) => {
    tepTree.value?.updateTepTree(filter);
}

const onCreateTreeData = (kod) => {
    tepTree.value?.createItemTepTree(kod);
}

const onRefreshCardData = () => {
    if(tepCardsStore.state.selectedItem) {
        const itemKod = tepCardsStore.state.selectedItem.kod;
        tepCards.value?.clearCard(itemKod);
        tepCardsStore.getSelectedItem(null);
    }
}
</script>

<style scoped>
.tep-view-main-container {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
#tep-tree-grid-container {
    width: 30%;
    min-width: 250px;
}
#tep-cards-container {
    width: 70%;
    min-width: 600px;
}
.tep-view-container {
    padding: 16px;
    height: 100%;
    position: relative;
}
.tep-view-container:after {
    content: '';
    display: block;
    border-right: 2px solid rgba(191, 191, 191, .7);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
}
:deep(.tep-loader-wrap-outer) {
    background-color: #fff7;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1000;
}
:deep(.tep-loader-wrap-inner) {
    width: 100%;
    height: 100%;
    position: relative;
}
</style>
